"use client"

import { useEffect } from "react"

import { captureLinkReferralCode, syncHostReferralCode } from "@/lib/referrals/attribution"
import { persistUTMParams } from "@/lib/services/utm"
import { captureFbclidToFbcCookie } from "@/platform/observability/analytics/meta"

export const UTMParamStorage = () => {
  useEffect(() => {
    captureFbclidToFbcCookie()
    captureLinkReferralCode()
    syncHostReferralCode()
    persistUTMParams()
    window.addEventListener("nelo:bridge-host-ready", syncHostReferralCode)
    return () => window.removeEventListener("nelo:bridge-host-ready", syncHostReferralCode)
  }, [])

  return null
}
